export default () => {
    const popupsMemberClose = document.querySelectorAll('.js-PopupMember-Close');
     
    if(popupsMemberClose){
      popupsMemberClose.forEach(popupMemberClose => {
        popupMemberClose.addEventListener('click', () => {
          window.history.back();
        })
      });
    }

}